import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import updateAutomaticRepliesViewState from '../../actions/automaticReplies/updateAutomaticRepliesViewState';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';
import {
    isAutomaticRepliesEnabledUtil,
    isAutomaticRepliesForEveryoneUtil,
    isAutomaticRepliesOnlyToMyOrganizationUtil,
    isDifferentReplyForOrgAndExtSenders,
} from 'mini-options-store/lib/utils';

/**
 * Update automatic replies view state with mailbox auto reply config
 */
const updateAutomaticRepliesViewStateMutator = mutator(
    updateAutomaticRepliesViewState,
    actionMessage => {
        const store = getOptionsStore();
        if (store) {
            const mailboxAutoReplyConfiguration = actionMessage.mailboxAutoReplyConfiguration;
            // For consumer both are same and to avoid conflict with OWA we do this.
            const internalMessage = isConsumer()
                ? mailboxAutoReplyConfiguration.ExternalMessageText
                : mailboxAutoReplyConfiguration.InternalMessageText;
            store.activeViewState = {
                name: ActiveItem.AutomaticReplies,
                isLoading: true,
                isDirty: false,
                isAutomaticRepliesEnabled: isAutomaticRepliesEnabledUtil(
                    mailboxAutoReplyConfiguration
                ),
                replyToExternalSendersText: mailboxAutoReplyConfiguration.ExternalMessageText,
                replyOnlyToMyOrganizationText: internalMessage,
                isReplyToEveryone: isAutomaticRepliesForEveryoneUtil(mailboxAutoReplyConfiguration),
                isReplyOnlyToMyOrganization: isAutomaticRepliesOnlyToMyOrganizationUtil(
                    mailboxAutoReplyConfiguration
                ),
                isDifferentReplyForOrgAndExternalSenders: isDifferentReplyForOrgAndExtSenders(
                    mailboxAutoReplyConfiguration
                ),
            } as ActiveOptionViewState;
        }
    }
);

export default updateAutomaticRepliesViewStateMutator;
